const getNestedValue = (row, field) => {
  if (!field) return undefined;
  return field.includes('.')
    ? field.split('.').reduce((obj, key) => obj?.[key], row)
    : row[field];
};

const formatObjectValue = (value) => {
  if (value == null) return '';
  if (Array.isArray(value)) {
    return value.map(formatObjectValue).filter(Boolean).join(', ');
  }
  if (typeof value === 'object') {
    const preferredKeys = ['name', 'title', 'label', 'discomName', 'zone', 'circle', 'division', 'id'];
    const preferredValues = preferredKeys
      .map((key) => value[key])
      .filter((item) => item != null && item !== '');

    if (preferredValues.length) {
      return preferredValues.join(' - ');
    }

    return Object.values(value)
      .filter((item) => item != null && typeof item !== 'object')
      .join(' - ');
  }
  return value;
};

const getExportColumns = (data, columns) => {
  if (columns?.length) {
    return columns
      .filter((column) => column.field !== 'checkbox')
      .map((column, index) => ({
        key: `${column.label || column.field || 'column'}-${index}`,
        header: column.label || column.field || `Column ${index + 1}`,
        getValue: (row) => {
          if (typeof column.exportValue === 'function') {
            return column.exportValue(row[column.field], row);
          }

          return formatObjectValue(getNestedValue(row, column.field));
        }
      }));
  }

  return Object.keys(data[0]).map((header) => ({
    key: header,
    header,
    getValue: (row) => formatObjectValue(row[header])
  }));
};

const escapeCsvValue = (value) => {
  const stringValue = value == null ? '' : String(value);
  if (/[",\n]/.test(stringValue)) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue;
};

const escapeHtml = (value) => String(value ?? '')
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#39;');

export const exportToCSV = (data, filename, columns) => {
  if (!data.length) return;

  const exportColumns = getExportColumns(data, columns);
  const csvContent = [
    exportColumns.map((column) => escapeCsvValue(column.header)).join(','),
    ...data.map((row) => exportColumns.map((column) => escapeCsvValue(column.getValue(row))).join(','))
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}.csv`;
  link.click();
  window.URL.revokeObjectURL(url);
};

export const exportToExcel = (data, filename, columns) => {
  if (!data.length) return;

  const exportColumns = getExportColumns(data, columns);
  const htmlTable = `
    <table>
      <thead><tr>${exportColumns.map((column) => `<th>${escapeHtml(column.header)}</th>`).join('')}</tr></thead>
      <tbody>${data.map((row) => `<tr>${exportColumns.map((column) => `<td>${escapeHtml(column.getValue(row))}</td>`).join('')}</tr>`).join('')}</tbody>
    </table>
  `;

  const blob = new Blob([htmlTable], { type: 'application/vnd.ms-excel' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}.xls`;
  link.click();
  window.URL.revokeObjectURL(url);
};
